module.exports = __webpack_public_path__ + "files/8791ec66af3a4cf96e403ff374862859.png";